import Model from './model';

export default class LogicBaseRelationship extends Model {
  constructor(_id, follower, followee, requested, lastStoryTime) {
    super();
    this._id = _id;
    this.follower = follower;
    this.followee = followee;
    this.requested = requested;
    this.lastStoryTime = lastStoryTime || null;
  }
  getJson = () => {
    const { _id, follower, followee, requested, lastStoryTime } = this;
    return {
      _id,
      fr: follower,
      fe: followee,
      r: requested,
      lst: lastStoryTime,
    }
  }
}
